import PropTypes from 'prop-types';

import { DomainStatus } from './domain-status';

export const DnsEntryPropType = PropTypes.shape({
  isValid: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  host: PropTypes.string.isRequired,
  data: PropTypes.string.isRequired,
});

export const DomainRecordPropType = PropTypes.shape({
  domainId: PropTypes.string,
  storeId: PropTypes.string,
  email: PropTypes.string,
  emailVerification: PropTypes.bool,
  domainVerificationStatus: PropTypes.oneOf(Object.values(DomainStatus)),
  dnsRecords: PropTypes.shape({
    mailCName: DnsEntryPropType,
    dKim1: DnsEntryPropType,
    dKim2: DnsEntryPropType,
  }),
  name: PropTypes.string,
});
